import { render, staticRenderFns } from "./WyhSettingFapiao.vue?vue&type=template&id=7648b818&scoped=true&"
import script from "./WyhSettingFapiao.vue?vue&type=script&lang=js&"
export * from "./WyhSettingFapiao.vue?vue&type=script&lang=js&"
import style0 from "./WyhSettingFapiao.vue?vue&type=style&index=0&id=7648b818&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7648b818",
  null
  
)

export default component.exports